// components/layout/Footer.jsx
export default function Footer() {
  return (
    <footer className="mt-10 border-t border-[#d9e5f6] bg-white/70 py-8 dark:border-[#2a3c57] dark:bg-[#111f33]/80">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 px-6 text-sm text-[#4e6384] dark:text-[#c3d8f8] md:flex-row">
        <p>© 2026 Thermo Fix • ყველა უფლება დაცულია</p>
        <p className="text-xs uppercase tracking-[0.14em] text-[#7091be] dark:text-[#89abe0]">
          Crafted for comfort
        </p>
      </div>
    </footer>
  );
}
